module.exports = __webpack_public_path__ + "staticcomp/img/content_2.3ca0b6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/10/content_2.jpg
// module id = 6sZ6
// module chunks = 39